import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";

import _ from "lodash";
import ApiUserTransaction from "../../../core/api/api.userTransaction";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { ViewModal } from "./ViewModal";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, MenuItem } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const UserTransactions = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    setError,
    reset,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [status, setstatus] = useState([]);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : getValues("pageNumber");
  const [showModalUserTransaction, setShowModalUserTransaction] = useState(false);
  const [selectedUserTransaction, setSelectedUserTransaction] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست انواع نوع های جدول تراکنشهای کاربر
        const data1 = await ApiUserTransaction.getUserTransactionStatus();
        setstatus(data1.data);
        // دریافت لیست تراکنش های کاربر
        const data = await ApiUserTransaction.getAllUserTransaction({
          fromDate: searchParams.get("fromDate"),
          toDate: searchParams.get("toDate"),
          fromAmount: searchParams.get("fromAmount"),
          toAmount: searchParams.get("toAmount"),
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          basketId: searchParams.get("basketId"),
          status: searchParams.get("status"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "fromDate", type: "datePicker" },
          { name: "toDate", type: "datePicker" },
          { name: "fromAmount", type: "text" },
          { name: "toAmount", type: "text" },
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "basketId", type: "text" },
          { name: "status", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.basketId) && !validateNumber(data.basketId)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    if (!_.isEmpty(data.fromAmount) && !validateNumberFromAmount(data.fromAmount)) return;
    data.pageNumber = getValues("pageNumber");
    data.fromAmount =
      data.fromAmount && data.fromAmount.length > 0
        ? data.fromAmount.replaceAll(" ", "").replaceAll(",", "")
        : undefined;
    data.toAmount =
      data.toAmount && data.toAmount.length > 0 ? data.toAmount.replaceAll(" ", "").replaceAll(",", "") : undefined;
    if (data.fromDate && typeof data.fromDate === "object") {
      data.fromDate = tools.DateFormat(data.fromDate);
    }
    if (data.toDate && typeof data.toDate === "object") {
      data.toDate = tools.DateFormat(data.toDate);
    }
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiUserTransaction.getAllUserTransaction(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/userTransactions?${queryString}`);
  };
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  const validateNumberFromAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };
  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست تراکنش های کیف پول کاربران</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تراکنش های ثبت شده</span>
          </h3>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="از تاریخ"
                                  onChange={(date) => {
                                    var toDate = getValues("toDate");
                                    onChange(date);
                                    if (!toDate || (date?.toDate && date?.toDate()?.getTime() > new Date(toDate).getTime())) {
                                      // Set the value of toDate to the same as toDate
                                      setValue("toDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ"
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberFromAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                  type="search"
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="status"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="وضعیت"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                >
                                  <MenuItem key={99} value={0}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {status?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {item.title}{" "}
                                    </MenuItem>
                                  ))}
                                  {/* <option value="select">----</option>
                                                    {status?.map((item, index) =>
                                                         <option   key={index} value={item.id} >{item.title}</option>
                                                    )} */}
                                </TextField>
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumber(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                  type="search"
                                />
                              )}
                            />
                            {errors.basketId && (
                              <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setShowModalUserTransaction={setShowModalUserTransaction}
                  setSelectedUserTransaction={setSelectedUserTransaction}
                />
              </Col>
              {showModalUserTransaction && (
                <ViewModal
                  showModalUserTransaction={showModalUserTransaction}
                  setShowModalUserTransaction={setShowModalUserTransaction}
                  selectedUserTransaction={selectedUserTransaction}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default UserTransactions;
